import { render } from "./resourceDetail.vue?vue&type=template&id=7bd37ba3&scoped=true&ts=true"
import script from "./resourceDetail.vue?vue&type=script&lang=ts"
export * from "./resourceDetail.vue?vue&type=script&lang=ts"

import "./resourceDetail.vue?vue&type=style&index=0&id=7bd37ba3&lang=scss&scoped=true"

import exportComponent from "D:\\work\\CP_new_work\\saas-h5-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bd37ba3"]])

export default __exports__